export default __webpack_public_path__ + "static/media/Bindings of the Unholy Communion.8a7a7aaf.jpg";